import React, { useEffect, useState } from "react";
import { Modal, Button, Card, Form } from "react-bootstrap";
import { LiaIdCard } from "react-icons/lia";
import { FaUpload } from "react-icons/fa6";
import axios from "axios";

const VerifyModal = ({ show, onHide, onSave, roomId }) => {
  console.log("show", show);

  return (
    <>
      <Modal centered show={show} onHide={onHide}>
        <Modal.Header closeButton style={{ backgroundColor: "#fff" }}>
          <Modal.Title className="fw-normal">
            Please verify you’re not a spammer
            <br />
            by doing this quick activity!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body closeButton>
          <div className="d-flex justify-content-between  gap-1 align-items-center ">
            <div className="row">
              <div className="col-12">
                <img src="assets/images/Verification.svg" alt="" />
              </div>
              <div className="col-12 text-start mt-4">
                <label
                  for="inputEmail4"
                  className="form-nadme mb-2 fs-14 fw-normal"
                >
                  Enter the Code<span className="text-danger psos">*</span>
                </label>
                <input
                  type="number"
                  name="fname"
                  id="fname"
                  className="form-control infput"
                  placeholder="Code"
                  value=""
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="px-3">
          <div className="row w-100">
            <div className="col text-start">
              <img src="assets/images/reload.svg" alt="" />
              <img src="assets/images/headphone.svg" alt="" className="mx-2" />
              <img src="assets/images/i.svg" alt="" />
            </div>
            <div className="col text-end">
              <button type="button" className="btndesignactive verify">
                Verify
                <img src="assets/images/right.png" alt="" />
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default VerifyModal;
